import React from 'react';
import { connect } from 'react-redux';
import Dashboard from '../../modules/Dashboard';
import AuthCheckWrapper from '../../modules/AuthCheckWrapper';

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <AuthCheckWrapper requireStrongAuthentication={false}>
        <Dashboard />
      </AuthCheckWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps)(DashboardPage);
